export const PAYMENT_STATUS = {
  CANCEL: "CANCEL",
  PAYSUCCESS: "PAYSUCCESS",
  RETURN: "RETURN",
  UNPROCESS: "UNPROCESS",
} as const;
